import { FC, memo, useRef } from 'react';
import { Box, Typography, IconButton, Button, Grow } from '@mui/material';
import Draggable from 'react-draggable';
import { Grip, X } from 'lucide-react';
import CasaAI from '../../../../shared/icons/CasaAI';
import styles from './MinimizedChatIcon.module.scss';
import useDraggableChat from "../../hooks/useDraggableChat";

interface MinimizedChatIconProps {
  onClick: () => void;
  onClose: () => void;
}

const MinimizedChatIcon: FC<MinimizedChatIconProps> = ({ onClick, onClose }) => {
    const {dragPosition, setDragPosition} = useDraggableChat();
    const nodeRef = useRef(null);

    const startPos = useRef({ x: 0, y: 0 });

    const handleStart = (e: any, data: any) => {
        startPos.current = { x: data.x, y: data.y };
    };

    const handleStop = (e: any, data: any) => {
        setDragPosition({ x: data.x, y: data.y });
    };

    return (
        <Draggable nodeRef={nodeRef}
                   position={dragPosition}
                   onStart={handleStart}
                   onStop={handleStop}
                   bounds="body"
        >
            <Box ref={nodeRef} className={styles.minimizedWrapper} sx={{ bottom: 20, left: 20 }}>
                <Grow in={true}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Box className={styles.pillContainer}>
                            <Button 
                                onClick={onClick} 
                                className={`non-draggable-button ${styles.gargiButton}`} 
                                disableElevation
                                disableRipple
                            >
                                <Box className={styles.iconCircle}>
                                    <CasaAI />
                                </Box>
                                <Typography className={styles.gargiText}>Gargi AI</Typography>
                            </Button>
                            
                            <Box className={styles.divider} />
                            
                            <IconButton 
                                onClick={onClose} 
                                className={`non-draggable-button ${styles.closeBtn}`}
                            >
                                <X size={20} color="#1F2937" />
                            </IconButton>
                        </Box>
                        
                        <IconButton className={styles.gripBtn}>
                            <Grip size={20} color="#4B5563" />
                        </IconButton>
                    </Box>
                </Grow>
            </Box>
        </Draggable>
    );
};

export default memo(MinimizedChatIcon);